<template>
  <b-container class="mt-5">
    <b-card>
      <b-skeleton width="50%" height="30px" class="mb-3"></b-skeleton>
      <b-row>
        <!-- Columna izquierda -->
        <b-col md="6">
          <b-skeleton width="80%" height="20px" class="mb-2"></b-skeleton>
          <b-skeleton width="100%" height="40px" class="mb-3"></b-skeleton>

          <b-skeleton width="80%" height="20px" class="mb-2"></b-skeleton>
          <b-skeleton width="100%" height="40px" class="mb-3"></b-skeleton>

          <b-skeleton width="45%" height="20px" class="mb-2"></b-skeleton>
          <b-row>
            <b-col cols="6">
              <b-skeleton width="100%" height="40px" class="mb-3"></b-skeleton>
            </b-col>
            <b-col cols="6">
              <b-skeleton width="100%" height="40px" class="mb-3"></b-skeleton>
            </b-col>
          </b-row>
        </b-col>

        <!-- Columna derecha -->
        <b-col md="6">
          <b-skeleton width="50%" height="20px" class="mb-2"></b-skeleton>
          <b-skeleton width="80%" height="40px" class="mb-3"></b-skeleton>

          <b-skeleton width="50%" height="20px" class="mb-2"></b-skeleton>
          <b-skeleton width="60%" height="40px" class="mb-3"></b-skeleton>
        </b-col>
      </b-row>

      <b-skeleton width="30%" height="45px" class="mt-3"></b-skeleton>
    </b-card>
  </b-container>
</template>

<script>
export default {};
</script>

<style>
</style>